import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, createCommentVNode as _createCommentVNode, createBlock as _createBlock, withCtx as _withCtx } from "vue"

const _hoisted_1 = ["href"]

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_v_image = _resolveComponent("v-image")
  const _component_splide_slide = _resolveComponent("splide-slide")
  const _component_splide = _resolveComponent("splide")

  return (_openBlock(), _createBlock(_component_splide, {
    class: "page-width m-auto flex w-full max-w-full items-center",
    options: {
      fixedWidth: '11.2%',
      arrows: false,
      pagination: false,
      drag: true,
      type: 'loop',
      perMove: 1,
      speed: '600',
      easing: 'ease',
      focus: 'center',
      mediaQuery: 'max',
      breakpoints: {
        768: {fixedWidth: `23.2%`, gap: `${$props.gap}px`},
      },
    }
  }, {
    default: _withCtx(() => [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.logosData, (logo, index) => {
        return (_openBlock(), _createBlock(_component_splide_slide, {
          key: index,
          class: "flex-center cursor-grab [&_img]:opacity-95 [&_picture]:opacity-90"
        }, {
          default: _withCtx(() => [
            (logo.url)
              ? (_openBlock(), _createElementBlock("a", {
                  key: 0,
                  href: logo.url
                }, [
                  _createVNode(_component_v_image, {
                    source: logo.image,
                    class: "max-h-32 w-auto tablet:max-h-44"
                  }, null, 8, ["source"])
                ], 8, _hoisted_1))
              : (_openBlock(), _createBlock(_component_v_image, {
                  key: 1,
                  source: logo.image,
                  class: "max-h-32 w-auto tablet:max-h-44"
                }, null, 8, ["source"]))
          ]),
          _: 2
        }, 1024))
      }), 128))
    ]),
    _: 1
  }, 8, ["options"]))
}